import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore } from '@alfresco/aca-shared/store';
import { ReloadCustomListTableAction, ReloadDataListElementsAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';

@Component({
  selector: 'smt-action-reload-table',
  templateUrl: './reload-table.component.html'
})
export class ReloadTableComponent {

  constructor(
    private store: Store<AppStore>,
  ) {}

  reloadTable() {
    this.store.dispatch(new ReloadDataListElementsAction(true, true));
    this.store.dispatch(new ReloadCustomListTableAction(false));
  }
}
